<template>
  <div class="hour-trading-trend">
    <div ref="chart" class="chart" />
    <div v-if="price || volume" class="crosshair" :class="{ position }">
      <div class="price">
        <span class="label">{{ $t('quote.kchart.price') + ':' }}</span>
        <span>{{ price | floatNum(stock) }}</span>
      </div>
      <div class="volume">
        <span class="label">{{ $t('quote.kchart.volume') + ':' }}</span>
        <span>{{ volume | largeNumber }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { HourTrading } from '@tigerbrokers/nebular'
import throttle from 'lodash/throttle'
import { mapGetters } from 'vuex'
import { TRADING_STATUS } from 'const/stock'

class Observer {
  constructor(vm, chart) {
    this.vm = vm
    this.chart = chart
  }

  update() {
    this.vm.update(this.chart.crosshair.value)
  }
}

export default {
  name: 'HourTradingChart',
  props: {
    data: Object,
    stock: Object
  },
  data() {
    return {
      price: null,
      volume: null,
      position: 'left'
    }
  },
  computed: {
    ...mapGetters(['isRedUp']),
    symbol() {
      return this.stock.symbol
    },
    timestamp() {
      return this.data && (this.data.timestamp || this.data.serverTime)
    },
    items() {
      return (this.data && this.data.items) || []
    },
    preClose() {
      return (this.data && this.data.preClose) || 0
    },
    isPreTrading() {
      return this.stock.tradingStatus === TRADING_STATUS.PRE_TRADING
    },
    config() {
      return {
        upColor: this.isRedUp ? 'var(--red)' : 'var(--green)',
        downColor: this.isRedUp ? 'var(--green)' : 'var(--red)',
        fontColor: 'var(--default-font-color)',
        crosshairColor: 'var(--crosshair-color)',
        crossLineColor: 'var(--cross-line-color)',
        crossFontColor: 'var(--cross-font-color)'
      }
    }
  },
  mounted() {
    this.update = throttle(info => {
      this.position = info.x < 146 ? 'right' : 'left'
      this.price = info.price
      this.volume = info.volume
    }, 30)
    this.draw()
  },
  methods: {
    draw() {
      if (this.chart) {
        this.chart.destroy()
      }
      this.chart = new HourTrading(
        this.$refs.chart,
        this.preClose,
        this.isPreTrading,
        this.items,
        this.config
      )
      this.chart.attach(new Observer(this, this.chart))
      this.chart.draw()
    }
  },
  watch: {
    timestamp() {
      this.draw()
    },
    symbol() {
      this.draw()
    },
    isRedUp() {
      this.draw()
    }
  }
}
</script>
<style lang="less" scoped>
.hour-trading-trend {
  position: relative;
  width: 100%;
  height: 170px;
  margin-bottom: 6px;
  .chart {
    width: 100%;
    height: 100%;
  }
  .crosshair {
    position: absolute;
    top: 0;
    padding: 5px;
    background-color: var(--chart-color);
    div {
      display: flex;
      justify-content: space-between;
    }
    .price {
      margin-bottom: 10px;
    }
    .label {
      margin-right: 10px;
    }
    &.left {
      left: 0;
    }
    &.right {
      right: 0;
    }
  }
}
</style>
